import { PolicyV2Type } from '../../../types/ApiV2'
import { hasPolicyCoverageRemaining } from '@dg-util'

export const sortPolicies = (policies: Partial<PolicyV2Type>[]) =>
  policies.sort(
    (prevDoc, nextDoc) =>
      new Date(nextDoc.InsuredFrom).valueOf() - new Date(prevDoc.InsuredFrom).valueOf()
  )

export const getPolicyActiveVersions = (policy: Partial<PolicyV2Type>) => {
  const now = new Date()

  return (
    policy?.Versions?.filter(
      (version: Partial<PolicyV2Type>) =>
        new Date(version.InsuredFrom) <= now &&
        // `InsuredTo` is the inclusive last day, so a version ending today is still
        // active — see hasPolicyCoverageRemaining (DFE-4112). The inclusive end does
        // NOT make two versions match at once: i2i hands over on adjacent days, never
        // overlapping ones (v3 ends 09-07, v4 starts 09-08).
        hasPolicyCoverageRemaining(version, now)
    ) ?? []
  )
}
